import React from 'react';
import { FormGroup, Label, CustomInput, FormFeedback } from 'reactstrap';
import Required from '../Required';
import { withTranslation } from 'react-i18next';

const CustomRadioBtn = ({
  id,
  label,
  data,
  value,
  checked,
  onChange,
  t,
  valueKey,
  labelKey,
  invalid,
  error,
  ...props
}) => {
  return (
    <FormGroup>
      <Label>
        {t(label)} {props.required && <Required />}
      </Label>
      {data.map((d) => (
        <CustomInput
          key={d[valueKey]}
          type="radio"
          name={id}
          id={d[valueKey]}
          label={t(d[labelKey])}
          checked={value === d[valueKey]}
          onChange={(e) => {
            if (onChange) {
              onChange(e.target.id);
            }
          }}
        />
      ))}
      {invalid && <FormFeedback>{t(error)}</FormFeedback>}
    </FormGroup>
  );
};

CustomRadioBtn.defaultProps = {
  data: [],
};

export default withTranslation('app')(CustomRadioBtn);
